import { Observable, from, timer, of, combineLatest, concat, BehaviorSubject } from 'rxjs';
import { map, mergeMap, shareReplay, switchMap, publishReplay, refCount, share, filter, concatMap } from 'rxjs/operators';
import { createPersistedStore } from './persistedStore.js';
import { getSchedule } from './services';
import { minuteOnMinuteInterval } from './util';
import { updateEventState } from './events';
import SendBird from 'sendbird';
import { get } from 'svelte/store';

export const NavLinks = [
  // {name: 'Home', icon: 'home', to: '/'},
  {name: 'Main Stage', icon: 'play_arrow', to: '/stage'},
  // {name: 'Schedule', icon: 'schedule', to: '/schedule'},
  // {name: 'New Partner Lounge', icon: 'groups', to: '/partners'},
  // {name: 'Marketing Materials', icon: '/img/icon-assets.png', to: '/assets/marketing'},
  // {name: 'Driving Experiences', icon: '/img/icon-video-360.png', to: '/assets/driving'},
  // {name: 'Tire Technology Videos', icon: '/img/icon-tire.png', to: '/assets/technology'}
];

export const SendbirdAppId = 'A6F8A6E6-04CA-42EB-9E49-15DE23873DD4';
export let sendBirdSubject = new BehaviorSubject();
export let sendBird = new SendBird({appId: SendbirdAppId, localCacheEnabled: false});
// export const timeUtc = writable();

export function getChannel(url) {
  return new Observable(subscriber => {
    let lChannel;
    const sub = sendBirdSubject.pipe(
      filter(sb => sb),
      concatMap(sb => new Promise((resolve, reject) => {
        sb.OpenChannel.getChannel(url, (channel, error) => {
          if (error) {
            reject(error)
            return;
          }
  
          channel.enter((response, error) => {
            if (error) {
              reject(error)
              return;
            }
  
            resolve(channel)
          })
        })
      }))
    ).subscribe(channel => {
      lChannel = channel;
      subscriber.next(channel)
    })

    return () => {
      sub.unsubscribe();
      lChannel?.exit()
    }
  })
}

const uid = function(){
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
}

export const user = createPersistedStore('user');
if (!get(user)?.id) {
  user.set({id: uid()})
}

// Event schedule store source
const minToMs = min => min * 60_000;
const refetchScheduleEvery = minToMs(20);

// User login/logout stream
const user$ = new Observable(subscriber => user.subscribe(usr => subscriber.next(usr))).pipe(share());

user$.subscribe(user => {
  if (user) {
    sendBird.connect(user.id, function(usr, error) {
      if (error) {
        console.error(error)
        return;
      }

      // Best-effort
      if (user.name) sendBird.updateCurrentUserInfo(user.name, '', () => {});
      sendBirdSubject.next(sendBird);
    })
  } else {
    // Calling connect with new user will correctly disconnect old sessions
    // sendBird.getConnectionState() !== 'CLOSED' && sendBird.disconnect()
    sendBirdSubject.next(undefined);
  }
});

// Schedule stream: either [], or schedule [] refreshed every `refetchScheduleEvery`
// Events are sorted by startTime
const events$ = user$.pipe(
  switchMap(u => u ? 
    timer(0, refetchScheduleEvery).pipe(
      mergeMap(_ => from(getSchedule())),
    ) :
    of([])
  ),
  shareReplay(1)
);

// Schedule stream where event state is refreshed every minute (shutsdown when no-one is listening)
// TODO add delay and update api
export const schedule$ = combineLatest([events$, concat(of(0), minuteOnMinuteInterval())]).pipe(
  map(([schedule, _]) => schedule),
  map(updateEventState),
  publishReplay(1),
  refCount()
);